module.exports = __webpack_public_path__ + "static/fionas-music-center-promo-4a817b80bb176288eeb747c85ef7110a.jpg";